<template>
  <div id="stars" class="px-3 px-sm-0">
    <v-row
      class="voting-stars"
      v-for="(star, index) in spot.raetsel.lsg"
      :key="index"
    >
      <v-col cols="12" md="6" class="voting-stars-p" :style="{'color': theme.textColor}">{{ star }}</v-col>
      <v-col cols="12" md="6" class="py-0">
        <v-rating :readonly="disableInteraction ? true : false"
          v-model="starsSelected[index]"
          :color="theme.btnColorPrimary"
          :background-color="theme.textColor"
          empty-icon="$ratingFull"
          clearable
          large
          @input="setSelectedStar(index, $event)"
        >
        </v-rating>
      </v-col>
    </v-row>
    <info-message
      v-if="votesAlertMessage"
      icon="mdi-alert-circle"
      :message="votesAlertMessage"
      isSticky
      backgroundColor="#FFFFFF"
    ></info-message>
  </div>
</template>

<script>
import {layoutMixin} from '@/utils/layout-mixin'
import {solutionMixin} from '@/utils/solution-mixin'
import InfoMessage from '@/components/spots/InfoMessage.vue';

export default {
  components: { InfoMessage },
  mixins:[layoutMixin,solutionMixin],
  props: {
    spot: {},
  },
  data: () => ({
    starsSelected: [],    
    starsObj: [],
    votesAlertMessage: '',
    final: [],
    disableInteraction: false,
  }),
  mounted(){
    this.setResponses();
    console.log("SEE this.spot.raetsel esp voting star",this.spot.raetsel);
    //display the message 
    if ( !this.disableInteraction && this.spot.raetsel.max_votes_exact && this.spot.raetsel.max_votes){
      this.votesAlertMessage = this.$tc("solveVotingMissingStars", this.spot.raetsel.max_votes, {d: (this.spot.raetsel.max_votes)});
    }
  },
  methods: {
     setResponses(){
      if ( this.spot.tstatus == 3 || this.spot.tstatus == 4 ){
        this.disableInteraction = true;   
        let inputJson = this.spot.raetsel.user_input_json;
        if(typeof this.spot.raetsel.user_input_json !== 'object'){
          inputJson = JSON.parse(this.spot.raetsel.user_input_json)
        }   
        this.spot.raetsel.lsg.forEach((element)=>{
          if (inputJson[element]){
            this.starsSelected.push(inputJson[element]);
          }else{
            this.starsSelected.push(0);
          }
        })        
      }
    },
    setSelectedStar(index) {
      //early return - prevent user interaction
      if (this.disableInteraction) return;     
      const result = this.spot.raetsel.lsg[index]+'('+this.starsSelected[index]+'/'+5+')';
      const foundIndex = this.starsObj.findIndex(Result=>Result.index==index);
      if (foundIndex!=-1){
        this.starsObj[foundIndex] = {result:result,index:index, stars:this.starsSelected[index]};
      }else{
        this.starsObj.push({result:result,index:index, stars:this.starsSelected[index]});
      }
      let input= [];
      let totalStarsSelected = this.totalStarsSelected();
      // continue if max votes has not been set or selected is less than max
      if( this.spot.raetsel.max_votes === 0 || totalStarsSelected <= this.spot.raetsel.max_votes ){
        // continue if max votes exact has not been set, or if set, check if selected equals max
        if( !this.spot.raetsel.max_votes_exact || totalStarsSelected === this.spot.raetsel.max_votes ){
          this.votesAlertMessage = '';
          this.starsObj.forEach(element=>{
            if(element.stars>0){
              input.push(element.result);
            }
          });
        }
        else{
            let stars = this.spot.raetsel.max_votes - totalStarsSelected;
          this.votesAlertMessage = this.$tc("solveVotingMissingStars", stars, {stars: stars});
        }
      }
      else{
        this.votesAlertMessage = this.$tc("solveVotingStarsFull", this.spot.raetsel.max_votes, {stars: this.spot.raetsel.max_votes});
      }
      let serverInput=this.getServerData(input, null, this.spot);
      this.$emit('input',input,serverInput);
    },
    totalStarsSelected(){
      let totalStars = 0;
      this.starsSelected.forEach(element=>{
        totalStars+=element;
      });
      return totalStars;
    },

  },
};
</script>

<style scoped lang="scss">
#stars {
  .voting-stars {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    .voting-stars-p {
      display: flex;
      align-items: center;
      color: #000;
    }
  }
}
</style>
